import { SelectBox } from "devextreme-react/select-box";
import { useEffect, useState } from "react";
import { CustomItemCreatingEvent } from "devextreme/ui/select_box";
import { Category } from "../model/ChecklistDtos";
import ChecklistQuestionsApi from "../api/ChecklistQuestionsApi";
import { StoreHelper } from "../../../core/localstorage/storeHelper";

interface CategorySelectorProps {
    data: { value: Category | null; setValue: (val: Category | null) => void };
    checklistId: number
}

export const CategorySelector: React.FC<CategorySelectorProps> = ({ data, checklistId }) => {
    const [categories, setCategories] = useState<Category[]>([]);

    const ownerLabel = { 'aria-label': 'category' };

    useEffect(() => {
        getCategories()
    }, [])

    const getCategories = async () => {
        let categories: Category[] = []
        if (checklistId) {
            categories = await ChecklistQuestionsApi.getCategories(checklistId);
        }

        const uniqueStoredCategories = StoreHelper.Categories.update(categories);

        setCategories([...categories, ...uniqueStoredCategories]);
    }

    const handleCustomItemCreating = (e: CustomItemCreatingEvent) => {
        if (!e.text || e.text === "") {
            e.customItem = { idChecklistQuestionCategory: null, name: "" };
            return;
        }

        const newCategory = { idChecklistQuestionCategory: null, name: e.text };
        StoreHelper.Categories.add(newCategory)

        e.customItem = newCategory;
    };

    const onValueChanged = (e: any) => {
        const selectedCategory = categories.find(c => c.name === e.value);

        if (e.value === null) {
            data.setValue(null);
        } else {
            data.setValue(selectedCategory ?? { idChecklistQuestionCategory: null, name: e.value });
        }

        setCategories([...categories])
    }

    return (
        <SelectBox
            dataSource={categories}
            displayExpr="name"
            valueExpr="name"
            value={data.value?.name}
            onValueChanged={onValueChanged}
            searchEnabled={true}
            acceptCustomValue={true}
            inputAttr={ownerLabel}
            onCustomItemCreating={handleCustomItemCreating} />
    );
};
